module.exports = __webpack_public_path__ + "static/img/home3-slider.abeeb27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home3/home3-slider.png
// module id = 4gOx
// module chunks = 36